import React, { Component } from 'react';
import HmacSha1 from 'hmac_sha1';

import Core from './../../../Core/Core'

import Header from './../../Header';
import Cars from './../../Car/Cars';
import Opinions from './../../Opinion/Opinions';
import Relations from './../../Relation/Relations';
import Apvs from './../../APV/Apvs';
import FileList from './../../FileList';
import FileUpload from './../../FileUpload';
import Edits from './../../Edit/Edits';
import ErrorBoundary from './../ErrorBoundary';

import Informations from './../../Client/Informations';
import Status from './../../Client/Status';

class Client extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "client" : {},
            "cars" : [], 
            "opinions" : [],
            "apvs" : [],
            "relations" : [], 
            "edits" : [],
            "household" : {},
            "area" : null,
        };
        this.timer = null;

        this.FileList = React.createRef();

        this.load(props.match.params.id);

        this.uploadDone = this.uploadDone.bind(this);
        
    }

    load(id)
    {
        Promise.all([
            Core.Instance.Request(Core.Address+"Client/"+id, null, "GET"),
            Core.Instance.Request(Core.Address+"Car/Client_id/"+id+"?by=date_delivery&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"APV/Client_id/"+id+"?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Relation/Client_id/"+id+"?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Edit/Client_id/"+id, null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/"+id+";*?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/*;"+id+"?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/*;"+id+";*?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Opinion/Client_id/"+id+"?by=date&order=desc", null, "GET"),
            Core.Instance.Request(Core.Address+"Proposal/Client_id/"+id, null, "GET"),
        ]).then((data) => {
            //Avis clients
            let opinions = data[5] != null ? data[5] : [];
            if(data[6] != null)
                opinions = opinions.concat(data[6]);
            if(data[7] != null)
                opinions = opinions.concat(data[7]);
            if(data[8] != null)
                opinions = opinions.concat(data[8]);
            opinions = opinions.sort((a,b) => {
                return parseInt(b.date) - parseInt(a.date)
            });
            //Historique relation client
            let relations = data[3] != null ? data[3] : [];
            if(data[9] != null){
                let proposals = data[9].map((p) => {
                    p.nature = "Proposition commerciale";
                    p.progress = p.sold ? "Vendu": "Pas Vendu";
                    return p;
                });
                relations = relations.concat(proposals);
            }
            //Véhicules possédés
            let cars = data[1] != null ? data[1] : [];
            let avg_duration = 0;
            let delivery_null = 0;
            for (let i = 1; i < cars.length; i++) {
                if(cars[i].date_delivery){
                    avg_duration += cars[i-1].date_delivery - cars[i].date_delivery;
                }else{
                    delivery_null++;
                }
            }
            if(cars.length - delivery_null > 0){
                avg_duration /= cars.length - delivery_null;
                if (cars[0]) {
                    cars[0].avg_duration = avg_duration;
                }
            }
            this.setState({
                "client" : data[0], 
                "cars" : cars,
                "apvs" : data[2] != null ? data[2] : [],
                "relations" : relations,
                "edits" : data[4] != null ? data[4].reverse() : [],
                "opinions" : opinions,
            });
            
            if(this.state.client.address){
                this.timer = setTimeout(() => {
                    Core.Instance.Request(Core.Address+"GetArea/?postal_code="+this.state.client.postal_code+"&city="+this.state.client.city, null, "GET")
                    .then((json) => {
                        this.setState({
                            "area" : json && json.length ? json[0].dealership : null
                        })
                    })
                }, 1000);
            }

            if(this.state.client.household){
                this.timer = setTimeout(() => {
                    Core.Instance.Request(Core.Address+"Client/"+this.state.client.household, null, "GET")
                    .then((json) => {
                        this.setState({
                            "household" : json != null ? json : []
                        })
                    })
                }, 1000);
            }
        });
    }


    uploadDone()
    {
        this.FileList.current.load(this.FileList.current.props.path);
    }

    render()
    {
        let title = "W-F: Fiche "+this.state.client.name;
        if(this.state.client.first_name)
            title += " " +this.state.client.first_name;

        document.title = title;

        return (
            <ErrorBoundary>
                <Header/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col mx-3">
                            <div className="row">
                                <div className="col-lg-6 col-sm-12 pr-lg-0">
                                    <Informations client={this.state.client}/>
                                </div>
                                <div className="col-lg-6 col-sm-12 pl-lg-0">
                                    <div className="card my-3 ml-2 informations">
                                        <div className="card-body d-flex flex-column flex-grow-1 overflow-hidden">
                                            <div className="card-title">
                                                <span className="h4">Avis client</span>
                                                <span className='float-right pt-1'>
                                                    <a href="#" className='' onClick={() => {
                                                        window.location.href="/opinions/edit/"+this.state.client.id;
                                                    }}
                                                    >
                                                        <li className='fas fa-pencil-alt'> </li> <u>Modifier</u>
                                                    </a>
                                                </span>
                                            </div>                                       
                                            <div className="table-responsive p-0">
                                                <Opinions opinions={ this.state.opinions} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col mx-3">
                            <div className="row">
                                <div className="col-lg-3 col-sm-12 pr-lg-0">
                                    <Status client={this.state.client}/>
                                </div>
                                <div className="col-lg-3 col-sm-12 px-lg-0">
                                    <div className="card mx-2">
                                        <div className="card-body">
                                            <h4 className="card-title mb-4">Secteur Affaire</h4>
                                            <div>
                                                <span className="text-secondary h6 mr-1">
                                                    <i className="fas fa-car mr-1"></i>
                                                    Concession :
                                                </span>
                                                <span className="float-right">
                                                    { this.state.area != null ? this.state.area : "Hors Secteur" }
                                                </span>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12 pl-lg-0">
                                    <div className="card ml-2 informations">
                                        <div className="card-body d-flex flex-column flex-grow-1 overflow-hidden">
                                            <div className="card-title">
                                                <span className="h4">Historique APV</span>
                                                <span className='float-right pt-1'>
                                                    <a href="#" className='' onClick={() => {
                                                        window.location.href="/apvs/edit/"+this.state.client.id;
                                                    }}
                                                    >
                                                        <li className='fas fa-pencil-alt'> </li> <u>Modifier</u>
                                                    </a>
                                                </span>
                                            </div>                                      
                                            <div className="table-responsive p-0">
                                                <Apvs apvs={ this.state.apvs} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <div className="card m-3 informations">
                                <div className="card-body d-flex flex-column flex-grow-1 overflow-hidden">
                                    <div className="card-title">
                                        <span className="h4">
                                            Véhicules possédés
                                        </span>
                                        <span className='float-right pt-1'>
                                            <a href="#" className='' onClick={() => {
                                                window.location.href="/cars/edit/"+this.state.client.id;
                                            }}
                                            >
                                                <li className='fas fa-pencil-alt'> </li> <u>Modifier</u>
                                            </a>
                                        </span>
                                    </div>
                                    <div className="table-responsive p-0">
                                        <Cars cars={ this.state.cars } />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <div className="card mx-3 informations">
                                <div className="card-body d-flex flex-column flex-grow-1 overflow-hidden">
                                    <div className="card-title">
                                        <span className="h4">
                                            Historique relation client { this.state.relations.length > 0 && <span className="badge badge-pill bg-green text-white">{ this.state.relations.length }</span> } 
                                        </span>
                                        <span className='float-right pt-1'>
                                            <a href="#" className='' onClick={() => {
                                                window.location.href="/relations/edit/"+this.state.client.id;
                                            }}
                                            >
                                                <li className='fas fa-pencil-alt'> </li> <u>Modifier</u>
                                            </a>
                                        </span>
                                    </div>
                                    <div className="table-responsive p-0">
                                        <Relations relations={ this.state.relations } />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 col-lg-6 pr-lg-0">
                            <div className="card mr-2 my-3 ml-3 informations h-100 mw-100">
                                <div className="card-body d-flex flex-column">
                                    <h4 className="card-title row no-gutters">Fichiers associés</h4>
                                    <div className="text-center mt-3 p-2 row flex-column no-gutters flex-grow-1 justify-content-center" style={{border: "2px dashed #969db1"}}>
                                        <h6 className="text-secondary">Glisser mon fichier ici</h6>
                                        <h6 className="text-secondary">ou</h6>
                                        <FileUpload uploadDone={ this.uploadDone } basePath={ "/Client/"+this.state.client.id+"/ "} />
                                    </div>
                                    {
                                        this.state.client.id != null && 
                                        <div>
                                            <FileList ref={this.FileList} path={ "/Client/"+this.state.client.id+"/" } />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-lg-6 pl-lg-0">
                            <div className="card ml-2 my-3 mr-3 informations">
                                <div className="card-body d-flex flex-column flex-grow-1 overflow-hidden">
                                    <h4 className="card-title">Historique des modifications</h4>
                                    <div className=" table-responsive p-0">
                                        <Edits edits={ this.state.edits } />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

export default Client;


// WEBPACK FOOTER //
// ./src/Components/Views/Client/Client.js